import type { MainSidebarOnboardingKey } from '@/types/internal/mainSidebarTypes'

interface OnboardingStepTranslationKeys {
  descriptionKey: string
  titleKey: string
}

const ONBOARDING_TOUR_VERSION = 'main-sidebar-v1'
const ONBOARDING_HELP_URL = 'https://docs.2work.de/share/pw4ay5h5lc/p/2-work-8gi2NFe6aQ'
const ONBOARDING_ORGANIZATIONS_PATH = '/relationships/organizations'

// Keep this order language-neutral; visible step copy is resolved through i18n keys below.
const ONBOARDING_STEP_ORDER: MainSidebarOnboardingKey[] = [
  'relations',
  'activities',
  'sales',
  'buying',
  'project',
  'accounting',
  'humanResources',
  'services',
  'stock',
  'marketing',
  'settings',
]

const ONBOARDING_STEPS = {
  accounting: {
    descriptionKey: 'onboarding.tour.steps.accounting.description',
    titleKey: 'onboarding.tour.steps.accounting.title',
  },
  activities: {
    descriptionKey: 'onboarding.tour.steps.activities.description',
    titleKey: 'onboarding.tour.steps.activities.title',
  },
  buying: {
    descriptionKey: 'onboarding.tour.steps.buying.description',
    titleKey: 'onboarding.tour.steps.buying.title',
  },
  humanResources: {
    descriptionKey: 'onboarding.tour.steps.humanResources.description',
    titleKey: 'onboarding.tour.steps.humanResources.title',
  },
  marketing: {
    descriptionKey: 'onboarding.tour.steps.marketing.description',
    titleKey: 'onboarding.tour.steps.marketing.title',
  },
  project: {
    descriptionKey: 'onboarding.tour.steps.project.description',
    titleKey: 'onboarding.tour.steps.project.title',
  },
  relations: {
    descriptionKey: 'onboarding.tour.steps.relations.description',
    titleKey: 'onboarding.tour.steps.relations.title',
  },
  sales: {
    descriptionKey: 'onboarding.tour.steps.sales.description',
    titleKey: 'onboarding.tour.steps.sales.title',
  },
  services: {
    descriptionKey: 'onboarding.tour.steps.services.description',
    titleKey: 'onboarding.tour.steps.services.title',
  },
  settings: {
    descriptionKey: 'onboarding.tour.steps.settings.description',
    titleKey: 'onboarding.tour.steps.settings.title',
  },
  stock: {
    descriptionKey: 'onboarding.tour.steps.stock.description',
    titleKey: 'onboarding.tour.steps.stock.title',
  },
} as const satisfies Record<MainSidebarOnboardingKey, OnboardingStepTranslationKeys>

export {
  ONBOARDING_HELP_URL,
  ONBOARDING_ORGANIZATIONS_PATH,
  ONBOARDING_STEP_ORDER,
  ONBOARDING_STEPS,
  ONBOARDING_TOUR_VERSION,
}

export type { OnboardingStepTranslationKeys }
